import React from 'react';

export const ScrollAnchorContext = React.createContext(null);

export default ScrollAnchorContext;
